import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchEventDetails } from '../../actions/event';
import { fetchResponses } from '../../actions/responses';
import { handleError } from '../../util/Errors';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import EmptyState from '../shared/EmptyState';
import Logger from '../../util/Logger';
import Event from '../../models/Event';
import Response from '../../models/Response';
import { ResponseGroup } from './ResponseGroup';
import './ResponsesList.css';
import commentsAll from '../../images/comment_blue.svg';
import { ResponseCard } from './ResponseCard';
import { EventQuestionType } from '../../models/EventQuestionType';
import { NavigationUtils } from '../../util/NavigationUtils';
import { PAGE_LINK_RESPONSES_EMPTY } from '../../constants';

class ResponsesList extends Component {

  constructor (props) {
    super(props);

    const { event, user } = props;
    if (!user) {
      Logger.assert('Missing user in ResponseList component');
    }

    if (!event) {
      Logger.assert('Missing event in ResponseList component');
    }
  }

  componentDidMount () {
    // Don't call fetch responses here or we enter an infinite loop...
  }

  fetchResponses = () => {
    const { fetchEventDetails, fetchResponses, event } = this.props;
    fetchEventDetails(Event.getId(event));
    fetchResponses(Event.getId(event));
  };

  componentDidUpdate (prevProps) {
    const { responsesError } = this.props;
    handleError(responsesError, prevProps.responsesError);
  }

  handleOnClickEmptyState = ($event) => {
    $event.preventDefault();

    NavigationUtils.openTab(PAGE_LINK_RESPONSES_EMPTY);
  };

  render () {
    const { event, responses, responsesError, noteworthyError, responsesLoading, editing, onSectionsSet } = this.props;
    const { barOffset, isNoteworthy, isTopRank, scrollingOffset, onItemClicked, noteworthy, isAllResponsesEnabled, isPdfRender } = this.props;

    const questionType = !!event ? Event.getQuestionType(event) : null;
    const isOpenEnded = questionType ? EventQuestionType.isOpenEndedType(questionType) : null;
    const isClosed = !!event ? Event.isClosed(event) : false;
    const votingMode = !!event ? Event.getVotingMode(event) : null;

    let title;
    if (isOpenEnded) {
      if (isClosed) {
        title = 'There were no responses.';
      } else {
        title = 'No responses yet.';
      }
    } else {
      if (isClosed) {
        title = 'There were no comments.';
      } else {
        title = 'No comments yet.';
      }
    }

    return (
      <div>
        {
          (responsesError || (isNoteworthy && noteworthyError))
            ? (
              <div className="responses-list d-flex h-100">
                <div className="m-auto h-100">
                  <ErrorAndRefresh
                    error="Failed to load Responses"
                    onRefresh={ this.fetchResponses } />
                </div>
              </div>
            )
            : responsesLoading
            ? (
              <div className="responses-list d-flex h-100">
                <div className="m-auto h-100">
                  <LoadingAndPulse
                    size={ 20 }
                    color="#3D9AE2"
                    whatIsLoading="Responses" />
                </div>
              </div>
            )
            : (responses && responses.length > 0)
              ? (
                isNoteworthy
                  ? (
                    <div className="responses-list print-card-header h-100">
                      <NoteworthyList
                        barOffset={ barOffset }
                        editing={ editing }
                        onItemClicked={ onItemClicked }
                        scrollingOffset={ scrollingOffset }
                        onSectionsSet={ onSectionsSet }
                        isAllResponsesEnabled={ isAllResponsesEnabled }
                        isPdfRender={ isPdfRender }
                        responses={ responses } />
                    </div>
                  )
                  : isTopRank
                  ? (
                    <div className="responses-list print-card-header h-100">
                      <TopList
                        barOffset={ barOffset }
                        responses={ responses }
                        scrollingOffset={ scrollingOffset }
                        isAllResponsesEnabled={ isAllResponsesEnabled }
                        isPdfRender={ isPdfRender }
                        votingMode={ votingMode }
                        onItemClicked={ onItemClicked }
                      />
                    </div>
                  )
                  : (
                    <div className="responses-list print-card-header h-100">
                      <AllList
                        barOffset={ barOffset }
                        noteworthy={ noteworthy }
                        responses={ responses }
                        votingMode={ votingMode }
                        isPdfRender={ isPdfRender }
                        onItemClicked={ onItemClicked }
                      />
                    </div>
                  )
              )
              : (
                <div className="responses-list d-flex print-card-header h-100">
                  <EmptyState
                    onClick={ this.handleOnClickEmptyState }
                    icon="info_outline"
                    image={ null }
                    title={ title }
                    message={ null }
                  />
                </div>
              )
        }
      </div>
    );
  }
}

class NoteworthyList extends React.Component {

  render () {
    const { responses, scrollingOffset, editing, onSectionsSet, onItemClicked, isAllResponsesEnabled } = this.props;
    return (
      <div className="col no-gutters responses">
        <ul>
          { responses.map(
            (r, i) => <ResponseCard
              key={ Response.getId(r) }
              response={ r }
              isNoteworthy={ true }
              isAllResponsesEnabled={ isAllResponsesEnabled }
              scrollingOffset={ scrollingOffset }
              editing={ editing }
              sections={ responses }
              index={ i }
              onSectionsSet={ onSectionsSet }
              onItemClicked={ onItemClicked }
            />) }
        </ul>
      </div>
    );
  }

}

class TopList extends React.Component {

  render () {
    const { responses, scrollingOffset, onItemClicked, isAllResponsesEnabled, votingMode, isPdfRender } = this.props;
    return (
      <div className="col no-gutters responses">
        { (votingMode === 'star-rating') ?
          isPdfRender ? (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-10" />
              <div className="col-2 page-break-avoid">
                <div className="row no-gutters responses-counts text-center font-weight-semibold">
                  <small className="col-6">Rating</small>
                  <small className="col-6">Comments</small>
                </div>
              </div>
            </div>
          ) : (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-10" />
              <div className="col-2 page-break-avoid">
                <div className="row no-gutters responses-counts">
                  <i className="col-6 material-icons all-rating">star</i>
                  <img
                    src={ commentsAll }
                    alt="Top Responses"
                    className="col-6 all-children" />
                </div>
              </div>
            </div>
          )
          :
          isPdfRender ? (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-9" />
              <div className="col-3 page-break-avoid">
                <div className="row no-gutters responses-counts text-center font-weight-semibold">
                  <small className="col-4">Likes</small>
                  <small className="col-4">Dislikes</small>
                  <small className="col-4">Replies</small>
                </div>
              </div>
            </div>
          ) : (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-9" />
              <div className="col-3 page-break-avoid">
                <div className="row no-gutters responses-counts">
                  <i className="col-4 material-icons all-likes">thumb_up</i>
                  <i className="col-4 material-icons all-dislikes">thumb_down</i>
                  <img
                    src={ commentsAll }
                    alt="Top Responses"
                    className="col-4 all-children" />
                </div>
              </div>
            </div>
          )
        }
        <ul>
          { responses.map(
            (r, i) => <ResponseCard
              key={ Response.getId(r) }
              isAllResponsesEnabled={ isAllResponsesEnabled }
              response={ r }
              rank={ i + 1 }
              votingMode={ votingMode }
              onItemClicked={ onItemClicked }
              scrollingOffset={ scrollingOffset } />) }
        </ul>
      </div>
    );
  }

}

class AllList extends React.Component {

  render () {
    const { noteworthy, responses, onItemClicked, votingMode, isPdfRender } = this.props;
    return (
      <div className="col no-gutters responses">
        { (votingMode === 'star-rating') ?
          isPdfRender ? (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-10" />
              <div className="col-2 page-break-avoid">
                <div className="row no-gutters responses-counts text-center font-weight-semibold">
                  <small className="col-4">Rating</small>
                  <small className="col-4">Likes</small>
                  <small className="col-4">Dislikes</small>
                </div>
              </div>
            </div>
          ) : (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-10" />
              <div className="col-2 page-break-avoid">
                <div className="row no-gutters responses-counts">
                  <i className="col-4 material-icons all-rating">star</i>
                  <i className="col-4 material-icons all-likes">thumb_up</i>
                  <i className="col-4 material-icons all-dislikes">thumb_down</i>
                </div>
              </div>
            </div>
          )
          :
          isPdfRender ? (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-9" />
              <div className="col-3 page-break-avoid">
                <div className="row no-gutters responses-counts text-center font-weight-semibold">
                  <div className="col-4" />
                  <small className="col-4">Likes</small>
                  <small className="col-4">Dislikes</small>
                </div>
              </div>
            </div>
          ) : (
            <div className="row no-gutters my-2 page-break-avoid">
              <div className="col-9" />
              <div className="col-3 page-break-avoid">
                <div className="row no-gutters responses-counts">
                  <div className="col-4" />
                  <i className="col-4 material-icons all-likes">thumb_up</i>
                  <i className="col-4 material-icons all-dislikes">thumb_down</i>
                </div>
              </div>
            </div>
          )
        }
        { responses.map(r => (
          <ResponseGroup
            key={ Response.getId(r) }
            noteworthy={ noteworthy }
            response={ r }
            votingMode={ votingMode }
            onItemClicked={ onItemClicked } />
        )) }
      </div>
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    responsesError: state.responses.error,
    noteworthyError: state.responses.noteworthyError,
    responsesLoading: state.responses.loading
  };
};

export default connect(mapStateToProps, {
  fetchEventDetails,
  fetchResponses
})(ResponsesList);
